import React from 'react';

import { useHistory } from 'react-router-dom';

import { InsightsNewIconDualTone, InsightsNewIconHover, InsightsNewIconSelected } from 'assets/assetsV1/iconComponents';

import { COMPANY_VISIER_ANALYSIS } from 'constants/ProjectConstants';
import { goToEmbeddedAnalytics } from 'constants/helper';

import { SubNavItem, NavMenuItem } from 'uiToolkitV1/NavBar';

import { HeaderIconContainer } from './common/styles';

const AnalyticsHeader = () => {
  const history = useHistory();
  return (
    <HeaderIconContainer>
      <NavMenuItem
        Icon={InsightsNewIconDualTone}
        HoverIcon={InsightsNewIconHover}
        ActiveIcon={InsightsNewIconSelected}
        title="Analytics"
        isBetaFeature
      >
        {COMPANY_VISIER_ANALYSIS.map((item) => (
          <HeaderIconContainer onClick={() => goToEmbeddedAnalytics(item.id, history)}>
            <SubNavItem
              key={item.id}
              Icon={InsightsNewIconDualTone}
              HoverIcon={InsightsNewIconDualTone}
              ActiveIcon={InsightsNewIconDualTone}
              title={item.name || ''}
            />
          </HeaderIconContainer>
        ))}
      </NavMenuItem>
    </HeaderIconContainer>
  );
};

export default AnalyticsHeader;
